/* eslint-disable import/order */
import './utils/initSentry';
import './libs';
import './styles/global.scss';
import 'systemjs/dist/system';
import 'dayjs/locale/zh-cn';
import * as Sentry from '@sentry/react';
import { enableES5 } from '@medlinker/redux-store/node_modules/immer';

import dta from '@doctorwork/web-report-sdk';
import app from './app/app';
import env from './shared/utils/env';

import disableWechatFontZoom from './utils/disableWechatFontZoom';

// 企鹅监控相关
if (env.appEnv !== 'dev' && env.nodeEnv === 'production') {
  //qa appid
  let appId = 'KKYzr4t1608619959112';

  if ((env.appEnv as 'dev' | 'qa' | 'prod') === 'prod') {
    appId = 'n66kAsC1608710275769';
  }

  // 企鹅监控
  window.monitor = dta({
    env: env.appEnv,
    appId,
    filterUrls: ['growingio.com', 'sentry-int.medlinker.com'],
    // @ts-ignore
    master: 'medlinker',
    isTraceId: true,
    traceIdHeaderName: 'X-Opentracing-Id',
    errcodeReport(res: any) {
      if (
        Object.prototype.toString.call(res) === '[object Object]' &&
        res.hasOwnProperty('errcode') &&
        res.errcode !== 0
      ) {
        return { isReport: true, errMsg: res.errmsg, code: res.errcode };
      }

      return { isReport: false };
    },
  });
}

disableWechatFontZoom();

if (env.isApp && env.isIos && !env.isMedgptApp) {
  import('fastclick').then(FastClick => {
    // @ts-ignore
    FastClick.attach(document.body);
  });
}

enableES5();

app.applyHoc([Sentry.withProfiler]);

app.mount(document.getElementById('micro-root')!);

app.getStore()!.dispatch.app.init({});
app.getStore()!.dispatch.medgptWlys.init({});
